import { Put, Get } from 'config/apiServiceConfig'

export type CancelExternalDriverPayloadType = {
  note: string
  orderID: number
  isMultiDropoff?: boolean
  locationID?: number
}

export const cancelExternalDriver = (payload: CancelExternalDriverPayloadType) =>
  Put<{ data: { is_success: boolean; message: string } }>({
    url: `/api/order/${payload.orderID}/external-driver/cancel`,
    data: payload,
  })

export const cancelExternalDriverV2 = (payload: CancelExternalDriverPayloadType) =>
  Put<{ data: { is_success: boolean; message: string } }>({
    url: `/api/v2/order/${payload.orderID}/external-driver/cancel`,
    data: payload,
  })

export const getExternalDriverRates = (params: Record<string, unknown>) =>
  Get<{
    data: {
      provider_name: string
      use_shipper: boolean
      rates: number
      service_type: string
    }[]
  }>({
    url: `/api/order/${params.orderID}/external-driver/rates`,
    urlParams: params,
  })
// axios.get(`${baseUrl}/api/order/${orderID}/external-driver/rates`, { params })
